import React from 'react';
import { Query } from 'react-apollo';
import { Link, navigate } from '@reach/router';
import Stepper from '../stepper/stepper';
import Section from '../section/section';
import PopularBakers from '../popular-bakers/popular-bakers';
import Banner from '../banner/banner';
import classes from './home.module.scss';
import { GET_PRODUCTS, GET_SEEN_PRODUCTS } from '../../queries';
import { CircularProgress } from '@material-ui/core';
import ProductList from '../product-list/product-list';

const getProductsWithOneImage = products => {
  return products.map((product: any) => ({
    ...product,
    image: product.imagesUrls[0]
  }));
};

const Home = () => {
  return (
    <div className={classes.home}>
      <Banner />
      <div className={classes.categories}>
        <Link to={'/categories'}>
          <div className={classes.wrapIcon}>
            <img src="/assets/menu.svg" alt="Усі категорії" />
          </div>
          <h3>Усі категорії</h3>
        </Link>
        <Link to={'/categories/Macaroni'}>
          <div className={classes.wrapIcon}>
            <img src="/assets/macaron.svg" alt="Макарони" />
          </div>
          <h3>Макарони</h3>
        </Link>
        <Link to={'/categories/Cakes'}>
          <div className={classes.wrapIcon}>
            <img src="/assets/cake-slice.svg" alt="Торти" />
          </div>
          <h3>Торти</h3>
        </Link>
        <Link to={'/categories/Caps'}>
          <div className={classes.wrapIcon}>
            <img src="/assets/cupcake.svg" alt="Капкейки" />
          </div>
          <h3>Капкейки</h3>
        </Link>
      </div>

      <Query query={GET_PRODUCTS}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            );
          }
          if (error) return <div>Error fetching products</div>;

          const { products } = data;
          const productsWithOneImage = getProductsWithOneImage(products);
          return (
            <div>
              <Section
                click={() => navigate('/categories/all')}
                title={'Каталог пропозицій'}
                count={productsWithOneImage.length}
              >
                <ProductList products={productsWithOneImage.slice(0, 4)} />
              </Section>
              <PopularBakers />
              <Query query={GET_SEEN_PRODUCTS}>
                {queryResult => {
                  if (queryResult.loading) return <CircularProgress />;
                  if (queryResult.error) return null;
                  const seenProducts = getProductsWithOneImage(
                    queryResult.data.seenProducts
                  );
                  return seenProducts.length ? (
                    <Section
                      click={() => navigate('/seen-products')}
                      title={'Нещодавно переглянуті'}
                      count={seenProducts.length}
                    >
                      <Stepper steps={seenProducts} />
                    </Section>
                  ) : null;
                }}
              </Query>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

export default Home;
